import classNames from "classnames";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import { DEFAULT_LANGUAGE } from "@/constants/languages";

import shortLinkLogoSrc from "../images/me-link-banner-logo.svg";
import pageLogoSrc from "../images/me-page-banner-logo.svg";

import styles from "./Banner.module.scss";

const BANNER_ROTATION_INTERVAL_MS = 5000;

const BANNERS = [
  {
    key: "mePage",
    href: "https://me-page.com/?utm_source=me-qr&utm_medium=banner&utm_campaign=sidebar_crosspromo&utm_content=me-page",
    logoSrc: pageLogoSrc,
    logoAlt: "Me Page logo",
    titleKey: "mePageBanner.title",
    btnKey: "mePageBanner.btn",
    entryClassName: styles.mePage,
    pillClassName: styles.pillMePage,
  },
  {
    key: "meShortLink",
    href: "https://me-short-link.com/?utm_source=me-qr&utm_medium=banner&utm_campaign=sidebar_crosspromo&utm_content=me-link",
    logoSrc: shortLinkLogoSrc,
    logoAlt: "Me Short Link logo",
    titleKey: "meShortLinkBanner.title",
    btnKey: "meShortLinkBanner.btn",
    entryClassName: styles.meShortLink,
    pillClassName: styles.pillMeShortLink,
  },
];

function Banner() {
  const { t, i18n } = useTranslation();
  const isDefaultLanguage = i18n.language.split("-")[0] === DEFAULT_LANGUAGE;
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % BANNERS.length);
    }, BANNER_ROTATION_INTERVAL_MS);

    return () => window.clearInterval(intervalId);
  }, []);

  const banner = BANNERS[activeIndex];

  return (
    <a
      href={banner.href}
      target="_blank"
      rel="noreferrer"
      className={classNames(
        "p-4 d-flex flex-column text-decoration-none border-0 mb-3",
        styles.entry,
        banner.entryClassName
      )}
    >
      <div className="d-flex flex-column justify-content-between flex-grow-1">
        <div>
          <img
            className="img-fluid mb-3"
            loading="lazy"
            src={banner.logoSrc}
            alt={banner.logoAlt}
          />
          <p
            className={classNames(
              "col-7 mb-4 fw-bold lh-sm",
              isDefaultLanguage ? "fs-4" : "fs-6"
            )}
          >
            <Trans i18nKey={banner.titleKey} components={{ br: <br /> }} />
          </p>
        </div>
        <div>
          <span
            className={classNames(
              "rounded d-inline-block py-2 px-3 fs-8 fw-bold w-auto",
              styles.pill,
              banner.pillClassName
            )}
          >
            {t(banner.btnKey)}
          </span>
        </div>
      </div>
    </a>
  );
}

export default Banner;
